import { Text } from "shared/components/Text";
import cn from "classnames";
import css from "./styles.module.scss";
import faqArrow from "assets/images/arrow-down.png";

export const FAQList = ({ content, setContent }) => {
  return content.map((el, i) => {
    return (
      <div key={el.question} className={css.contentItemContainer}>
        <button
          onClick={() => {
            setContent((prev) => {
              const newContent = prev.map((el, index) => {
                if (index === i) {
                  el.isAnswerVisible = !el.isAnswerVisible;
                }
                return el;
              });
              return newContent;
            });
          }}
          className={cn(css.contentQuestionContainer, {
            [css.contentQuestionContainerLighter]: i % 2,
          })}
        >
          <Text
            type="white"
            className={css.contentQuestion}
            secondaryFamily
            bold
            size="subTitle"
          >
            {i + 1}. {el.question}
          </Text>
          <img
            src={faqArrow}
            alt="faq arrow"
            className={cn(css.faqArrowImage, {
              [css.reversed]: el.isAnswerVisible,
            })}
          />
        </button>
        {el.isAnswerVisible && (
          <Text type="white" className={css.content} size="body">
            {el.answer}
          </Text>
        )}
      </div>
    );
  });
};
